import store from '@/state/store';
import { get } from '@/api/project';
import { AccessErrorCodes } from '@bimdata/definitions/errors';
import logout from '../authentication/logout.action';
import { ApiError } from '@bimdata/client';
import projectSlice from '@/state/project.slice';
import reportError from './report-error.action';
import commonSlice from '@/state/common.slice';
import { Logger } from '@bimdata/client';
import t from '@/utils/translate';

const handleError = (error: Error, accessToken?: string): Error => {
  if (error instanceof ApiError) {
    switch (error.code) {
      case 403:
        error.message = handleForbiddenError(error, accessToken) || error.message;
        break;
      case 426:
        handleUpgradeRequiredError(error);
        Logger.error(error);
        return error;
      default:
        error.message = (error.exceptionCode && t(`error.api.ex${error.exceptionCode}`)) || error.message;
        break;
    }
    reportError(error);
    return error;
  }

  throw error;
};

const handleUpgradeRequiredError = (error: ApiError): string | undefined => {
  let message;

  store.dispatch(
    commonSlice.actions.blockApplication(
      !!error.method && ['GET', 'HEAD', 'OPTIONS'].includes(error.method.toUpperCase())
    )
  );

  return message;
};

const handleForbiddenError = (error: ApiError, accessToken?: string): string | undefined => {
  let message;

  switch (error.exceptionCode) {
    case AccessErrorCodes.PROJECT_ACCESS_DENIED:
      message = t('project.error.notFoundOrAccessDenied');

      if (!error.details?.projectId) {
        //store.dispatch(projectSlice.actions.close());
        break;
      }

      onProjectAccessDeniedAsyncEffect(error.details.projectId, accessToken);
      break;
    case AccessErrorCodes.USER_BLOCKED:
    case AccessErrorCodes.USER_NOT_EXIST:
      logout();
      break;
  }

  return message;
};

const onProjectAccessDeniedAsyncEffect = async (projectId: string, accessToken?: string) => {
  try {
    const p = await get(projectId, accessToken);
    store.dispatch(
      projectSlice.actions.setAccess({
        code: projectId,
        access: p.access
      })
    );
  } catch (e) {
    if (
      (e instanceof ApiError) &&
      (e.code === 403) &&
      (e.exceptionCode === AccessErrorCodes.PROJECT_ACCESS_DENIED)
    ) {
      //store.dispatch(projectSlice.actions.close());
      store.dispatch(projectSlice.actions.removeProject(projectId));
      return;
    }
    handleError(e, accessToken);
  }
};

export default handleError;